module.exports = __webpack_public_path__ + "assets/2b84b06ec91a53de7ad1d7cc1d288876-DSC_0749.jpg";